/*
 * @Author: cc
 * @LastEditTime: 2022-08-18 14:35:22
 */
import { InitMenuColumnId, MenuColumnIdProps } from "@root/actions/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: MenuColumnIdProps = InitMenuColumnId;

export const menuColumnIdSlice = createSlice({
  name: "menuColumnId",
  initialState,
  reducers: {
    setMenuColumnId: (state, action: PayloadAction<MenuColumnIdProps>) => {
      state = action.payload;
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
const { actions, reducer } = menuColumnIdSlice;
export const { setMenuColumnId } = actions;
export default reducer;
